function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { stringifyError } from '@shared/utils/errorUtils';
export var ServerCollection = /*#__PURE__*/ function(ServerCollection) {
    ServerCollection["ServerLogs"] = "Logs";
    ServerCollection["IncomingRequests"] = "IncomingRequests";
    ServerCollection["ServerOutgoingRequests"] = "OutgoingRequests";
    ServerCollection["DBResourceOverUsage"] = "DBResourceOverUsage";
    ServerCollection["UserTelemetry"] = "UserTelemetry";
    ServerCollection["UserFeedback"] = "UserFeedback";
    return ServerCollection;
}({});
export class ServerLogger {
    get logger() {
        return this._logger;
    }
    init(winstonLogger) {
        this._logger = winstonLogger;
    }
    debug(message, _param) {
        var { operation = '', operationModifier = '', page = '', collection = "Logs" } = _param, loggerMetadata = _object_without_properties(_param, [
            "operation",
            "operationModifier",
            "page",
            "collection"
        ]);
        const { correlationId, requestId } = this.context;
        if (this._logger) {
            this._logger.debug(message, _object_spread({
                correlationId,
                requestId,
                operation,
                operationModifier,
                page,
                collection
            }, loggerMetadata));
        }
    }
    info(message, _param) {
        var { operation = '', operationModifier = '', page = '', collection = "Logs" } = _param, loggerMetadata = _object_without_properties(_param, [
            "operation",
            "operationModifier",
            "page",
            "collection"
        ]);
        const { correlationId, requestId } = this.context;
        if (this._logger) {
            this._logger.info(message, _object_spread({
                correlationId,
                requestId,
                operation,
                operationModifier,
                page,
                collection
            }, loggerMetadata));
        }
    }
    warning(message, _param) {
        var { operation = '', operationModifier = '', page = '', collection = "Logs" } = _param, loggerMetadata = _object_without_properties(_param, [
            "operation",
            "operationModifier",
            "page",
            "collection"
        ]);
        const { correlationId, requestId } = this.context;
        if (this._logger) {
            this._logger.warn(message, _object_spread({
                correlationId,
                requestId,
                operation,
                operationModifier,
                page,
                collection
            }, loggerMetadata));
        }
    }
    error(message, _param) {
        var { operation = '', operationModifier = '', page = '', collection = "Logs", error } = _param, loggerMetadata = _object_without_properties(_param, [
            "operation",
            "operationModifier",
            "page",
            "collection",
            "error"
        ]);
        const { correlationId, requestId } = this.context;
        // The payload of the error might be changed!
        if (this._logger) {
            this._logger.error(message, _object_spread({
                correlationId,
                requestId,
                operation,
                operationModifier,
                page,
                collection,
                error: stringifyError(error || '')
            }, loggerMetadata));
        }
    }
    constructor(){
        _define_property(this, "_logger", void 0);
        _define_property(this, "context", void 0);
        this.context = {
            correlationId: '',
            requestId: ''
        };
    }
}
